module.exports = __webpack_public_path__ + "1646fa876da76eb831a7b1a7895d5c05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/watermelon-s.png
// module id = 2800
// module chunks = 0